import { LocationDescriptor } from "history";
import { useEffect, useState } from "react";
import * as React from "react";
import { Redirect as RouterRedirect } from "react-router-dom";

const Redirect: React.FC<React.ComponentProps<typeof RouterRedirect>> = ({ to, ...props }) => {
  const [route, setRoute] = useState<LocationDescriptor>();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    Array.from(searchParams.keys()).forEach(key => {
      if (!key.toLowerCase().startsWith("utm")) {
        searchParams.delete(key);
      }
    });

    const toParams = to.toString();
    const toQueryParamPoint = toParams.indexOf("?");
    const toWithoutParams = toQueryParamPoint === -1 ? toParams : toParams.slice(0, toQueryParamPoint);
    const toQueryParams = new URLSearchParams(toQueryParamPoint === -1 ? "" : toParams.slice(toQueryParamPoint));
    toQueryParams.forEach((value, key) => {
      searchParams.append(key, value);
    });

    const resultParams = searchParams.toString();

    setRoute({
      pathname: toWithoutParams,
      search: resultParams.length > 0 ? `?${resultParams}` : "",
      hash: window.location.hash,
    });
  }, [to]);

  return route ? <RouterRedirect to={route} {...props} /> : null;
};

export default Redirect;
